import { render, staticRenderFns } from "./CompositeValueEditor.vue?vue&type=template&id=3906a61c&"
import script from "./CompositeValueEditor.vue?vue&type=script&lang=js&"
export * from "./CompositeValueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports